export default __webpack_public_path__ + "static/CEO-Blog-Img-2f898947a51265b2fe3191a342a0088c.webp";